import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import NavMenu from "../components/NavMenu";
import Info from "../components/Info";
import FloatingActionButton from "../components/FloatingActionButton";
import ClassDashboard from "../components/ClassDashboard";
import QualityDashboard from "../components/QualityDashboard";
import { AnimatePresence, motion } from "framer-motion";
import NewEnrolment from "../components/NewEnrolment";
import Reenrolment from "../components/Reenrolment";
import Attendance from "../components/Attendance";

function Home() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const initialView = location.state?.view || "class";
  const [view, setView] = useState(initialView);

  const currentYear = new Date().getFullYear();
  const passedQuarter = location.state?.selectedQuarter ?? "";
  const passedYear = location.state?.selectedYear ?? "";

  const [selectedYear, setSelectedYear] = useState(passedYear || currentYear);
  const [selectedQuarter, setSelectedQuarter] = useState(passedQuarter || "");

  const commonProps = {
    expanded,
    setExpanded,
    selectedYear,
    selectedQuarter,
    setSelectedQuarter,
  };

  const renderView = () => {
    switch (view) {
      case "class":
        return (
          <motion.div
            key="class"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <ClassDashboard {...commonProps} />
          </motion.div>
        );
      case "quality":
        return (
          <motion.div
            key="quality"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <QualityDashboard {...commonProps} />
          </motion.div>
        );
      case "new":
        return (
          <motion.div
            key="new"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <NewEnrolment {...commonProps} />
          </motion.div>
        );
      case "reenrolment":
        return (
          <motion.div
            key="reenrolment"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <Reenrolment {...commonProps} />
          </motion.div>
        );
      case "attendance":
        return (
          <motion.div
            key="attendance"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <Attendance {...commonProps} />
          </motion.div>
        );
      default:
        return (
          <motion.div
            key="default"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <ClassDashboard {...commonProps} />
          </motion.div>
        );
    }
  };

  return (
    <div style={{ minHeight: "100vh", color: "#fff" }}>
      <NavMenu />
      {!expanded && (
        <Info
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedQuarter={selectedQuarter}
          setSelectedQuarter={setSelectedQuarter}
        />
      )}
      <AnimatePresence mode="wait">{renderView()}</AnimatePresence>
      {!expanded && <FloatingActionButton setView={setView} />}
    </div>
  );
}

export default Home;
